import React from 'react';
import { observable } from 'mobx';
import { Optional, ServiceStatus } from 'services/base/types';
import { IAccountsDomain, InvoiceMap, PangolinMap, PaymentMap, Prices, User } from './types';

export class AccountsDomain implements IAccountsDomain {
  @observable.ref
  status: ServiceStatus;

  @observable.deep
  user: Optional<User>;

  @observable.deep
  pangolins: PangolinMap;

  @observable.deep
  payments: PaymentMap;

  @observable.deep
  invoices: InvoiceMap;

  @observable.deep
  prices: Optional<Prices>;

  constructor() {
    this.status = ServiceStatus.FRESH;
    this.user = undefined;
    this.pangolins = new PangolinMap();
    this.payments = new PaymentMap();
    this.invoices = new InvoiceMap();
    this.prices = undefined;
  }
}

export const GlobalAccountsDomain = new AccountsDomain();

export const AccountsDomainContext: React.Context<IAccountsDomain> = React.createContext(GlobalAccountsDomain);
export const AccountsDomainProvider = AccountsDomainContext.Provider;
export const AccountsDomainConsumer = AccountsDomainContext.Consumer;
export type AccountsDomainProps = { accounts: IAccountsDomain };
export function withAccountsDomain<T>(Component: React.ComponentType<T & AccountsDomainProps>) {
  const WrappedComponent: React.FunctionComponent<T> = (props: T) => (
    <AccountsDomainConsumer>
      {accounts => <Component {...props} accounts={accounts}/>}
    </AccountsDomainConsumer>
  );
  WrappedComponent.displayName = Component.displayName;
  return WrappedComponent;
}

export function useAccountsDomain(): IAccountsDomain {
  return React.useContext(AccountsDomainContext);
}
